import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import Index from "./pages/Index";
import WhySons from "./pages/WhySons";
import Cabanas from "./pages/Cabanas";
import Tubing from "./pages/Tubing";
import Glamping from "./pages/Glamping";
import PropertyMap from "./pages/PropertyMap";
import FAQs from "./pages/FAQs";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import NotFound from "./pages/NotFound";
import BookNow from "./pages/BookNow";
import BookGeronimo from "./pages/BookGeronimo";
import BookRiverRanch from "./pages/BookRiverRanch";
import BookRiverRanchOvernight from "./pages/BookRiverRanchOvernight";
import BookBlueRiverCamp from "./pages/BookBlueRiverCamp";
import BookBlueRiverCampOvernight from "./pages/BookBlueRiverCampOvernight";
import BookRioCibolo from "./pages/BookRioCibolo";
import BookRioCiboloOvernight from "./pages/BookRioCiboloOvernight";
import BookSonsIsland from "./pages/BookSonsIsland";
import BookSonsGuadalupe from "./pages/BookSonsGuadalupe";
import BookSonsGuadalupeOvernight from "./pages/BookSonsGuadalupeOvernight";
import BookSonsIslandOvernight from "./pages/BookSonsIslandOvernight";
import Waivers from "./pages/Waivers";
import ThankYou from "./pages/ThankYou";
import Specials from "./pages/Specials";
import Blog from "./pages/Blog";
import BlogSpringBreak2026 from "./pages/BlogSpringBreak2026";
import BlogTubingGuadalupeNewBraunfels from "./pages/BlogTubingGuadalupeNewBraunfels";
import BlogFunThingsKidsNewBraunfels from "./pages/BlogFunThingsKidsNewBraunfels";
import BlogTubingWithKids from "./pages/BlogTubingWithKids";
import BlogTubeRentalNewBraunfels from "./pages/BlogTubeRentalNewBraunfels";
import BlogCabanaPriceIncluded from "./pages/BlogCabanaPriceIncluded";
import BlogRiverRoadNewBraunfels from "./pages/BlogRiverRoadNewBraunfels";
import BlogBestTimeToTube from "./pages/BlogBestTimeToTube";
import BlogSchlitterbahnVsTubing from "./pages/BlogSchlitterbahnVsTubing";
import BlogTubingPackingList from "./pages/BlogTubingPackingList";
import BlogRiverSafety from "./pages/BlogRiverSafety";
import BlogMemorialDay2026 from "./pages/BlogMemorialDay2026";
import BlogGuadalupeRiverFacts from "./pages/BlogGuadalupeRiverFacts";
import BlogJuly4th2026 from "./pages/BlogJuly4th2026";
import BlogLaborDay2026 from "./pages/BlogLaborDay2026";
import BlogKayakingGuadalupe from "./pages/BlogKayakingGuadalupe";
import BlogStressFreeFamilyTubing from "./pages/BlogStressFreeFamilyTubing";
import BlogRiverRoadParkingGuide from "./pages/BlogRiverRoadParkingGuide";
import BlogBestStretchGuadalupe from "./pages/BlogBestStretchGuadalupe";
import CabanaVsPicnicTable from "./pages/CabanaVsPicnicTable";
import TentCampingNewBraunfels from "./pages/TentCampingNewBraunfels";
import FamilyGetawaysNewBraunfels from "./pages/FamilyGetawaysNewBraunfels";
import PrivateVsPublicGuadalupe from "./pages/PrivateVsPublicGuadalupe";
import RiverRoadCabinsGuide from "./pages/RiverRoadCabinsGuide";
import LuxuryGlampingNewBraunfels from "./pages/LuxuryGlampingNewBraunfels";
import MemorialDayNewBraunfels from "./pages/MemorialDayNewBraunfels";
import GroupBookings from "./pages/GroupBookings";
import Double from "./pages/Double";
import OGPhotos from "./pages/OGPhotos";
import Sitemap from "./pages/Sitemap";
import AdminSeo from "./pages/AdminSeo";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/why-sons" element={<WhySons />} />
          <Route path="/cabanas" element={<Cabanas />} />
          <Route path="/tubing" element={<Tubing />} />
          <Route path="/glamping" element={<Glamping />} />
          <Route path="/property-map" element={<PropertyMap />} />
          <Route path="/OGPhotos" element={<OGPhotos />} />
          <Route path="/ogphotos" element={<OGPhotos />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cancellation" element={<CancellationPolicy />} />
          <Route path="/book-now" element={<BookNow />} />
          <Route path="/book-now/geronimo" element={<BookGeronimo />} />
          <Route path="/book-now/river-ranch" element={<BookRiverRanch />} />
          <Route path="/book-now/river-ranch-overnight" element={<BookRiverRanchOvernight />} />
          <Route path="/book-now/blue-river-camp" element={<BookBlueRiverCamp />} />
          <Route path="/book-now/blue-river-camp-overnight" element={<BookBlueRiverCampOvernight />} />
          <Route path="/book-now/rio-cibolo" element={<BookRioCibolo />} />
          <Route path="/book-now/rio-cibolo-overnight" element={<BookRioCiboloOvernight />} />
          <Route path="/book-now/sons-island" element={<BookSonsIsland />} />
          <Route path="/book-now/sons-island-overnight" element={<BookSonsIslandOvernight />} />
          <Route path="/book-now/sons-guadalupe" element={<BookSonsGuadalupe />} />
          <Route path="/book-now/sons-guadalupe-overnight" element={<BookSonsGuadalupeOvernight />} />
          <Route path="/specials" element={<Specials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/spring-break-2026-sons-river-ranch" element={<BlogSpringBreak2026 />} />
          <Route path="/blog/tubing-guadalupe-river-new-braunfels" element={<BlogTubingGuadalupeNewBraunfels />} />
          <Route path="/blog/fun-things-to-do-with-kids-near-new-braunfels" element={<BlogFunThingsKidsNewBraunfels />} />
          <Route path="/blog/tubing-with-kids-guadalupe-river" element={<BlogTubingWithKids />} />
          <Route path="/blog/guadalupe-river-tube-rental-near-new-braunfels" element={<BlogTubeRentalNewBraunfels />} />
          <Route path="/blog/cabana-rentals-price-whats-included" element={<BlogCabanaPriceIncluded />} />
          <Route path="/blog/river-road-new-braunfels-guide" element={<BlogRiverRoadNewBraunfels />} />
          <Route path="/blog/best-time-to-tube-guadalupe-river" element={<BlogBestTimeToTube />} />
          <Route path="/blog/schlitterbahn-vs-tubing-guadalupe" element={<BlogSchlitterbahnVsTubing />} />
          <Route path="/blog/what-to-pack-tubing-guadalupe-river" element={<BlogTubingPackingList />} />
          <Route path="/blog/guadalupe-river-water-levels-safety" element={<BlogRiverSafety />} />
          <Route path="/blog/memorial-day-weekend-guadalupe-river" element={<BlogMemorialDay2026 />} />
          <Route path="/blog/guadalupe-river-facts-guide" element={<BlogGuadalupeRiverFacts />} />
          <Route path="/blog/4th-of-july-guadalupe-river" element={<BlogJuly4th2026 />} />
          <Route path="/blog/labor-day-weekend-guadalupe-river" element={<BlogLaborDay2026 />} />
          <Route path="/blog/kayaking-guadalupe-river-new-braunfels" element={<BlogKayakingGuadalupe />} />
          <Route path="/blog/stress-free-family-tubing-guadalupe" element={<BlogStressFreeFamilyTubing />} />
          <Route path="/blog/river-road-parking-guide-new-braunfels" element={<BlogRiverRoadParkingGuide />} />
          <Route path="/blog/best-stretch-guadalupe-river-new-braunfels" element={<BlogBestStretchGuadalupe />} />
          <Route path="/cabana-vs-picnic-table" element={<CabanaVsPicnicTable />} />
          <Route path="/tent-camping-new-braunfels" element={<TentCampingNewBraunfels />} />
          <Route path="/family-getaways-new-braunfels" element={<FamilyGetawaysNewBraunfels />} />
          <Route path="/private-vs-public-guadalupe" element={<PrivateVsPublicGuadalupe />} />
          <Route path="/river-road-new-braunfels-cabins" element={<RiverRoadCabinsGuide />} />
          <Route path="/luxury-glamping-new-braunfels" element={<LuxuryGlampingNewBraunfels />} />
          <Route path="/memorial-day-weekend-new-braunfels" element={<MemorialDayNewBraunfels />} />
          <Route path="/group-bookings" element={<GroupBookings />} />
          <Route path="/waivers" element={<Waivers />} />
           <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/guadalupe-river-glamping" element={<Navigate to="/" replace />} />
            <Route path="/tubing-1" element={<Navigate to="/tubing" replace />} />
            <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
            <Route path="/picnic-tables" element={<Navigate to="/cabanas#picnic-tables" replace />} />
            <Route path="/day-rentals" element={<Navigate to="/cabanas" replace />} />
            {/* Squarespace legacy URL redirects */}
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/tubing/" element={<Navigate to="/tubing" replace />} />
            <Route path="/about" element={<Navigate to="/why-sons" replace />} />
            <Route path="/about-us" element={<Navigate to="/why-sons" replace />} />
            <Route path="/reservations" element={<Navigate to="/book-now" replace />} />
            <Route path="/booking" element={<Navigate to="/book-now" replace />} />
            <Route path="/gallery" element={<Navigate to="/OGPhotos" replace />} />
            <Route path="/photos" element={<Navigate to="/OGPhotos" replace />} />
            <Route path="/directions" element={<Navigate to="/property-map" replace />} />
            <Route path="/location" element={<Navigate to="/property-map" replace />} />
            <Route path="/amenities" element={<Navigate to="/cabanas" replace />} />
           <Route path="/double" element={<Double />} />
           <Route path="/sitemap" element={<Sitemap />} />
           <Route path="/admin/seo" element={<AdminSeo />} />
           {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
